var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProjectTypeIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 17,
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.92677 0.600586C3.56812 0.600586 0.00195312 4.16675 0.00195312 8.5254C0.00195312 12.8841 3.56812 16.4502 7.92677 16.4502C12.2854 16.4502 15.8516 12.8841 15.8516 8.5254C15.8516 4.16675 12.2854 0.600586 7.92677 0.600586ZM7.92677 14.8653C4.43193 14.8653 1.58692 12.0202 1.58692 8.5254C1.58692 5.03056 4.43193 2.18555 7.92677 2.18555C11.4216 2.18555 14.2666 5.03056 14.2666 8.5254C14.2666 12.0202 11.4216 14.8653 7.92677 14.8653ZM3.96436 10.9028H11.8892V12.4878H3.96436V10.9028ZM6.57955 7.89142L5.07384 6.3857L3.96436 7.49518L6.57955 10.1104L11.8892 4.80074L10.7797 3.69126L6.57955 7.89142Z",
  fill: "#B7BDD1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProjectTypeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/projectTypeIcon.9c38990a031a7a5a4e030aee3598aef9.svg";